/*
 * Public API Surface of ngx-stars
 */

export * from './lib/ngx-stars.component';
export * from './lib/ngx-stars.module';
